import { set } from "@ember/object"
import Service from "@ember/service"

export default class Dialog extends Service {
  deffered = new Promise(() => {})
  templateName = null
  isOpen = false
  options = null
  resolve = null
  reject = null

  blank(templateName, opts) {
    this.deffered = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
    let options = Object.assign({ substrate: true }, opts)
    set(this, "templateName", templateName)
    set(this, "options", options)
    set(this, "isOpen", true)
    return this.deffered
  }

  accept() {
    this.resolve(...arguments)
    set(this, "isOpen", false)
  }

  decline() {
    this.reject(...arguments)
    set(this, "isOpen", false)
  }
}
